/**
 * ZohoCustomerType: Classifies Zoho customers by business tier.
 *
 * Used in:
 * - Zoho contact custom field (index 3): Type of customer
 * - Estimate creation: SMB customers get retainer invoice settings
 *
 * Values:
 * - SMB: Small/Medium Business — estimates pushed with accept_retainer=true, retainer_percentage=100
 * - ENTERPRISE: Enterprise customer — standard estimate without retainer
 */
export enum ZohoCustomerType {
  SMB = 'SMB',
  ENTERPRISE = 'ENTERPRISE',
}
